import { Alert } from 'react-bootstrap';

const EditUserInfoAlert = () => (
  <Alert variant="info">
    <small>
      <strong>Note:</strong> To change this user's password, use the “Password”
      button from the user list.
    </small>
  </Alert>
);

export default EditUserInfoAlert;